/******************************************************************************
 * @Author                : Jbristhuille<jbristhuille@gmail.com>              *
 * @CreatedDate           : 2025-02-05 16:47:42                               *
 * @LastEditors           : Jbristhuille<jbristhuille@gmail.com>              *
 * @LastEditDate          : 2025-03-04 15:41:33                               *
 *****************************************************************************/

/* SUMMARY
  * Imports
  * Components
  * AdminSettings: Admin settings view
*/

/* Imports */
import { Typography } from "@material-tailwind/react";
import { t } from "i18next";
/***/

/* Components */
import { TabsNav } from "../../../../components/tabs/TabsNav";
import AdminLanguagesTab from "./tabs/Languages/AdminLanguagesTab";
import { BuildingOfficeIcon, ClockIcon, FlagIcon, GlobeEuropeAfricaIcon, TruckIcon } from "@heroicons/react/24/solid";
import AdminActivitySectorTab from "./tabs/activity-sector/AdminActivitySectorTab";
import AdminZonesTab from "./tabs/zones/AdminZonesTab";
import AdminTechnicianTimeTypesTab from "./tabs/technician-time-types/AdminTechnicianTimeTypesTab";
import AdminReportsTab from "./tabs/reports/AdminReportsTab";
import { DocumentIcon, PhotoIcon, BeakerIcon } from "@heroicons/react/24/solid";
import AdminPhotoCategoriesTab from "./tabs/photo-categories/AdminPhotoCategoriesTab";
import AdminFeatureFlagsTab from "./tabs/feature-flags/AdminFeatureFlagsTab";
/***/

/**
* AdminSettings: Admin settings view
*/
export default function AdminSettings() {
  const tabs = [{
    label: t("settings:tabs:languages"),
    icon: FlagIcon,
    value: "languages",
    Component: AdminLanguagesTab
  }, {
    label: t("settings:tabs:zones"),
    icon: GlobeEuropeAfricaIcon,
    value: "zones",
    Component: AdminZonesTab
  }, {
    label: t("settings:tabs:activitySector"),
    icon: BuildingOfficeIcon,
    value: "activity",
    Component: AdminActivitySectorTab
  }, {
    label: t("settings:tabs:technicianTimeTypes"),
    icon: ClockIcon,
    value: "technician-time-types",
    Component: AdminTechnicianTimeTypesTab
  }, {
    label: t("settings:tabs:reports"),
    icon: DocumentIcon,
    value: "reports",
    Component: AdminReportsTab
  }, {
    label: t("settings:tabs:photoCategories"),
    icon: PhotoIcon,
    value: "photo-categories",
    Component: AdminPhotoCategoriesTab
  }, {
    label: t("settings:tabs:featureFlags"),
    icon: BeakerIcon,
    value: "feature-flags",
    Component: AdminFeatureFlagsTab
  }];

  return (
    <div className="views-padded">
      <div className="my-4">
        <div className="flex justify-between items-center actions">
          <Typography variant="h4">{t("settings:title")}</Typography>
        </div>
      </div>

      <TabsNav<any> defaultTab="languages" tabs={tabs} data={{}} />
    </div>
  );
}
/***/
